import $ from 'jquery';

/* global x5script */

class Comments {
  constructor() {
    this.form = $('.js-comments-form');

    if (!this.form.length) {
      return;
    }

    this.formErrors = x5script.commentsFormErrors;
    this.validateComment();
  }

  static validateEmail(email) {
    // eslint-disable-next-line no-useless-escape
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(email).toLowerCase());
  }

  validateComment() {
    this.form.attr('novalidate', true);

    const requiredFields = this.form.find('[required="required"]');

    this.form.on('submit', e => {
      const self = $(e.target);
      const invalid = [];
      const fieldError = self.find('.js-field-error');

      if (fieldError.length) {
        fieldError.remove();
      }

      if (requiredFields.length) {
        $.each(requiredFields, (i, el) => {
          const field = $(el);
          const value = field.val().trim();

          if (value === '') {
            invalid.push({
              element: field,
              error: this.formErrors.fieldEmpty,
            });
          } else if (field.attr('name') === 'email') {
            if (!Comments.validateEmail(value)) {
              invalid.push({
                element: field,
                error: this.formErrors.invalidEmail,
              });
            }
          }
        });

        if (invalid.length > 0) {
          $.each(invalid, (i, field) => {
            field.element
              .parent()
              .append(
                `<p class="c-comment__field-error js-field-error">${
                  field.error
                }</p>`,
              );
          });

          $('body, html')
            .stop()
            .animate(
              {
                scrollTop: self.offset().top - 200,
              },
              300,
            );

          return false;
        }
      }

      return true;
    });
  }
}

export default new Comments();



// WEBPACK FOOTER //
// ./src/scripts/modules/comments.js